import * as React from 'react'
import { Article, FeaturedArticle, HelpCenterWidgetCard, WidgetCardBaseProps } from "../../../../types"
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { generatePath } from '../../../utilities/RouteHelper'
import ERoute from '../../../ERoute'
import { useTranslation } from 'react-i18next'
import Card from '../Card'
import Icon from '../../../../components/Icons/Icon'
import { HelpCenterController as MessengerHelpCenterController } from '../../../controllers'
import MobilityHelper from '../../../../helpers/MobilityHelper'
import HelpCenterController from '../../../../help_center/controllers/HelpCenterController'
import { FeaturedArticlesController } from '../../../../controllers'

const Container = styled(Card)`
  padding: 8px;
`

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  line-height: 21px;
`

const HelpButton = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 40px;
  box-sizing: border-box;
  padding: 10px 12px;
  font-weight: 600;
  background: rgb(245, 245, 245);
  color: black;
  border-radius: 8px;
  transition: background 250ms;
  text-decoration: none;

  &:hover {
    color: rgb(0, 0, 0);
    background: rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
  }
`

const ArticleTitle = styled(Link)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  min-height: 40px;
  box-sizing: border-box;
  padding: 8px 12px;
  color: rgb(108, 111, 116);
  border-radius: 8px;
  transition: background 250ms;
  text-decoration: none;

  &:hover {
    background: rgba(0, 0, 0, 0.1);
  }

  svg {
    width: 16px;
    height: 16px;
    min-width: 16px;
    min-height: 16px;
  }
`

interface IState {
  featuredArticles: FeaturedArticle[]
}

type IProps = WidgetCardBaseProps & {
  card: HelpCenterWidgetCard
  admin?: boolean
}

const HelpCenter = (props: IProps) => {
  const { widget, locale, admin } = props
  const { t } = useTranslation()
  const [state, setState] = React.useState<IState>({ featuredArticles: [] })

  const fetchFeaturedArticles = async () => {
    let featuredArticles: Article[] = []

    try {
      if (admin) {
        const featured_articles = await FeaturedArticlesController.getArticles(widget.help_center_id)
        featuredArticles = featured_articles
      } else {
        const { featured_articles } = await MessengerHelpCenterController.getOverview()
        featuredArticles = featured_articles
      }



      setState({ featuredArticles: featuredArticles })
    } catch (ex) {
      console.error(ex)
    }
  }

  React.useEffect(() => {
    if (!widget.help_center_id) return

    fetchFeaturedArticles().catch(console.error)
  }, [])

  const { featuredArticles } = state
  const localeFeaturedArticles = featuredArticles.filter(article => Boolean(MobilityHelper.getTranslation(locale, article.article.translations, 'title')))

  return (
    <Container>
      <Wrapper>
        <HelpButton to={generatePath(ERoute.PATH_HELP, { focusSearch: true })}>
          {t('HelpCenterWidgetCard::Search for help')}

          <Icon icon='messenger-search' />
        </HelpButton>

        {localeFeaturedArticles?.slice(0, 4)?.map(featuredArticle => {
          const title = MobilityHelper.getTranslation(locale, featuredArticle.article.translations, 'title')

          return (
            <ArticleTitle key={featuredArticle.id} to={generatePath(ERoute.PATH_ARTICLE, { id: featuredArticle.article.id })}>
              {title}
              <Icon icon='messenger-chevron-right' />
            </ArticleTitle>
          )
        })}
      </Wrapper>
    </Container>
  )
}

export default HelpCenter